import React, { useState } from "react";
import { View, StyleSheet, Text, Platform } from "react-native";

import Dialog from "../../common/dialog";
import AppTheme from "../../AppTheme";
import ManaButton from "../../common/ManaButton";
import appStyles from "../../../appStyles";
import ThrowToTrashIcon from "../../common/icons/integrations/ThrowToTrashIcon";
import HealthBigIcon from "../../common/icons/integrations/HealthBigIcon";

export default function DeleteAccountDialog({
  onContinue = () => {},
  close = () => {},
}) {
  const [isConfirmed, setIsConfirmed] = useState(false);

  return (
    <Dialog.Container
      onClose={close}
      showCloseButton
      style={styles.container}
      headerStyle={{ margin: 0 }}
      contentStyle={{
        marginTop: 0,
        paddingTop: 8,
        paddingBottom: 12,
        minHeight: 295,
      }}
    >
      <View style={styles.header}>
        <Text style={styles.title}>
          {isConfirmed ? "Confirm delete all data" : "Are you sure?"}
        </Text>
        <Text style={styles.description}>
          {isConfirmed ? (
            <>
              Tapping confirm will delete your account and all data associated
              with it. Please be very careful{" "}
              <Text style={{ fontWeight: 600 }}>
                - there is no undo for this action.
              </Text>
            </>
          ) : (
            "Tapping confirm will delete your account."
          )}
        </Text>
      </View>

      <View style={styles.media}>
        {isConfirmed ? (
          <HealthBigIcon width={141} height={129} />
        ) : (
          <ThrowToTrashIcon />
        )}
      </View>

      <View style={[styles.buttons, { marginTop: "auto" }]}>
        <ManaButton
          style={[styles.button, appStyles.buttonShadow]}
          styleText={styles.buttonText}
          text="Cancel"
          onPress={close}
        />

        <ManaButton
          isMainButton
          style={[styles.button, styles.buttonConfirm]}
          styleText={styles.buttonConfirmText}
          text={isConfirmed ? "Delete account and all data" : "Confirm"}
          onPress={isConfirmed ? onContinue : () => setIsConfirmed(true)}
        />
      </View>
    </Dialog.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
  },
  close: {
    position: "absolute",
    top: 5,
    right: 5,
  },
  header: {
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
  description: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    textAlign: "center",
    marginTop: 16
  },
  media: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  buttons: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 8,
  },
  button: {
    width: "auto",
    minWidth: 140,
    height: 32,
    paddingHorizontal: 12,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#DD5F43",
  },
  buttonConfirm: {
    backgroundColor: "#DD5F43",
    marginLeft: 8,
  },
  buttonConfirmText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#FFF",
  },
});
